import { Api } from "./api"

export class CupperSummaryApi extends Api {
  constructor() {
    super('summary', [], { prefix: "cuppers" })
  }
}
